import { useLocation } from 'react-router';
import { Stack } from '../../design-system/stack/stack';
import Header from '../layout/header';
import { PaymentsPageWrapper } from './payments-section/payments-section-wrapper';

export const PaymentsPage = () => {
  const location = useLocation();

  return (
    <Stack align="stretch" className="min-h-screen p-2.5">
      <Stack align="stretch" className="flex-1 overflow-clip rounded-lg bg-white">
        <div className="overflow-clip rounded-lg">
          {/* The key prop forces a component re-render, which scrolls the user to the top of the page when switching between beneficiary table views */}
          <Header key={location.search} />
        </div>

        <PaymentsPageWrapper />
      </Stack>
    </Stack>
  );
};
